module.exports = __webpack_public_path__ + "media/images/long-arrow-486003cd37b06de72d37fa77140c3bd6.svg";